import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputFilePDF from "#core/components/input/file/InputFilePDF"
import InputSelect from "#core/components/input/select/InputSelect"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseContextPromotionColaborador } from "#promotions/contexts/ContextPromotionColaborador"
import {
	promotionDetailsIdFilePost,
	promotionFileTypeGet,
} from "#promotions/services/api"
import { Box } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import { toast } from "react-toastify"

const initialValues = {
	file_type: "",
	file: null,
}

export default function FileForm({ values, setValues, disabled, exclude = [] }) {
	const { data, error, loading } = useApi(promotionFileTypeGet, {
		autoFetch: true,
	})
	const files_types = useMemo(
		() => data?.data?.filter((item) => !exclude.includes(item.id)) || [],
		[data, exclude]
	)

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
			<div style={{ display: "flex", justifyContent: "right", gap: "1rem" }}>
				<InputSelect
					label="Tipo de archivo"
					options={files_types}
					value={values.file_type}
					setValue={(e) => setValues((old) => ({ ...old, file_type: e }))}
					optionsId={"id"}
					optionsLabel={"name"}
					disabled={disabled}
				/>
			</div>
			<InputFilePDF
				label="Seleccionar pdf"
				value={values.file}
				setValue={(value) => setValues((old) => ({ ...old, file: value }))}
			/>
		</Box>
	)
}

export const candidateFileFormValidation = (values) => {
	if (!values.file_type) {
		toast.error("El tipo de archivo es obligatorio")
		return false
	}
	if (!values.file) {
		toast.error("El archivo es obligatorio")
		return false
	}
	return true
}

export const FileFormDialog = ({ open, setOpen, data, exclude = [] }) => {
	const { refreshFiles, detailId } = UseContextPromotionColaborador()
	const [values, setValues] = useState(data ?? initialValues)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		setValues(initialValues)
		refreshFiles()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch } = useApiSend(promotionDetailsIdFilePost, { success, end })

	const handleSubmit = useCallback(() => {
		if (!candidateFileFormValidation(values)) return
		setDisabled(true)

		let formData = new FormData()
		formData.append("file_type", values.file_type)
		formData.append("file", values.file)

		fetch(detailId, formData)
	}, [fetch, values, detailId])

	const handleClose = useCallback(() => {
		setOpen(false)
		setValues(initialValues)
	}, [setOpen])

	return (
		<DialogMaster
			{...{
				title: data?.id ? "Editar archivo" : "Agregar archivo",
				setOpen,
				open,
				handleSubmit,
				disabled,
				onClose: handleClose,
				maxWidth: "xs",
			}}
		>
			<FileForm {...{ values, setValues, disabled: !!data, exclude }} />
		</DialogMaster>
	)
}
